"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toastrReducer = void 0;

var _actions = require("./actions");

var toastrReducer = function toastrReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload,
      type = action.type;

  switch (type) {
    case _actions.ADD_TOAST:
      return state.filter(function (t) {
        return t.id !== payload.toast.id;
      }).concat(payload.toast);

    case _actions.REMOVE_TOAST:
      return state.filter(function (t) {
        return t.id !== payload.id;
      });

    default:
      return state;
  }
};

exports.toastrReducer = toastrReducer;
//# sourceMappingURL=reducer.js.map